import { CarteOpportunites } from '@components/carte-opportunites/models';
import { Block } from '@shared/models';

export const carteOpportunitesMock: Block<CarteOpportunites> = {
  type: 'carte-opportunites',
  data: {
    contactUrl: '/ouvrir-un-magasin/contact',
  },
};
